import { defineStore } from "pinia"
import { computed, ref, watch } from "vue"
import { useUserStore } from "./user"

export const useSimulatorStore = defineStore(
  "simulator",
  () => {
    const userStore = useUserStore()
    const storedResult = ref({})
    const resultOwnerId = ref(null)
    const isCurrentOwner = () => resultOwnerId.value != null
      && String(resultOwnerId.value) === String(userStore.user?.userId)
    const result = computed({
      get: () => isCurrentOwner() ? storedResult.value : {},
      set: value => {
        resultOwnerId.value = userStore.user?.userId ?? null
        storedResult.value = resultOwnerId.value == null ? {} : (value || {})
      },
    })
    function clearResult() {
      storedResult.value = {}
      resultOwnerId.value = null
    }
    function setResultForOwner(value, userId, token) {
      if (userId == null || String(userId) !== String(userStore.user?.userId)
          || token !== userStore.accessToken) return false
      result.value = value
      return true
    }
    watch(() => userStore.user?.userId, clearResult, { flush: "sync" })
    return { result, storedResult, resultOwnerId, clearResult, setResultForOwner }
  },
  {
    persist: {
      storage: sessionStorage,
      paths: ["storedResult", "resultOwnerId"],
      afterRestore: ({ store }) => {
        // 소유자 정보 없는 구버전 캐시는 복원하지 않는다.
        delete store.$state.result
        if (String(store.resultOwnerId) !== String(useUserStore().user?.userId)) store.clearResult()
      },
    },
  },
)
